<script>
    import { fade } from "svelte/transition";
    import { questions, craft, lang } from "../scripts/stores";
    import { emptyAllQuestions } from "../scripts/utils";

    export let open = false;
    let element;

    function emptyValues() {
        const check = confirm("Haluatko varmasti tyhjentää kaikki vastaukset?");
        if(check) $questions = emptyAllQuestions($questions);
    }

    function saveAsCraft() {        
        $questions = $questions;
        $craft = $questions;
    }

    function loadCraft() {
        if(!$craft) return;

        $questions = $craft;
        $craft = null;
        localStorage.removeItem("craft");
    }

    function handleClickOutside(e) {
        const { target } = e;

        if(target === element || target.parentNode === element) return;
        else open = false;
    }

    $: 
        if(open) {
            document.body.addEventListener("click", handleClickOutside);
        }
        else {
            document.body.removeEventListener("click", handleClickOutside);
        }

    function toggleMenu() {
        open = !open;
    }

</script>

<style>
    .tools {
        background: #fff;
        position: fixed;
        bottom: 6rem;
        right: 1rem;
        z-index: 100;
    }
    .open-btn {
        position: fixed;
        bottom: 1rem;
        right: 1rem;
        z-index: 100;
        background: #db2e69;
    }
    .open-btn:hover {
        transition: .1s;
        background: #db2e69;
    }
    @media screen and (min-width: 800px) {
        .open-btn:hover {
            transition: .1s;
            background: #db2e68cc;
        }
    }
    .active {
        transform: rotate(-45deg);
    }
    .material-icons {
        margin-right: .6rem;
    }
</style>

<button class="btn btn-circle btn-lg open-btn {open ? "" : "active"}" on:click={ toggleMenu } bind:this={ element }>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="inline-block w-6 h-6 stroke-current">   
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>                       
    </svg>
</button> 

{#if open}
    <ul class="menu p-4 shadow-lg bg-base-100 rounded-box tools" in:fade={{ duration: 200 }}>
        <li class="menu-title"> <span>Työkalut</span> </li> 
        <li>
            <a href="javascript:void(0)" on:click={ saveAsCraft }>
                <i class="material-icons">save</i>
                { $lang == "fi" ? "Tallenna luonnos" : "Save survey as draft"}                
            </a>
        </li> 
        <li>
            <a disabled={ !$craft } style={ $craft ? "" : "text-decoration: line-through;" } 
               href="javascript:void(0)" on:click={ loadCraft }
            >
                <i class="material-icons">upload</i>
                { $lang == "fi" ? "Lataa luonnos" : "Upload survey"}                
            </a>
        </li> 
        <li>
            <a href="javascript:void(0)" on:click={ emptyValues }>
                <i class="material-icons">clear</i>
                { $lang == "fi" ? "Tyhjennä valinnat" : "Clear all answers"}                
            </a>
        </li> 
        <li>
            <a href="/#/results-page">
                <i class="material-icons">bar_chart</i>
                { $lang == "fi" ? "Siirry tulokseen" : "To results" }
            </a>
        </li>
    </ul>
{/if}